<template>
  <div v-if="defineBanner">
    <div
      class="f360-banner-aviso-financeiro"
      :style="{ backgroundColor: defineBanner.backgroundColor }"
    >
      <div class="content-left" :style="{ color: defineBanner.textColor }">
        <div
          class="icon-wrapper"
          :style="{
            border: `1px solid ${defineBanner.color}`,
            borderRadius: '50%'
          }"
        >
          <material-icon
            :icon="defineBanner.icon"
            class="icon hidden-sm-and-down"
            :style="{ color: defineBanner.color }"
          />
        </div>
        <p style="line-height: 18px">
          {{ qtd > 1 ? defineBanner.plural : defineBanner.singular }}
        </p>
      </div>
      <div class="content-right">
        <el-button class="banner-button" @click="handleLink">
          <span class="banner-button__label">
            <span
              class="display-btn-text hidden-sm-and-down"
              style="color: #0089d4; text-decoration: underline"
              >Regularize aqui
            </span>
            <MaterialIcon
              class="banner-button__icon"
              icon="north_east"
              style="color: #0089d4"
            />
          </span>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ElButton } from "element-plus/es/components/button/index";
import MaterialIcon from "@/components/MaterialIcon.vue";
import { computed } from "vue";
import { EFinanceiroButton, EFinanceiroButtonGetter } from "./types";

const props = defineProps<{
  tipo: EFinanceiroButton;
  qtd: number;
}>();

const emits = defineEmits(["VCBannerClick"]);

const handleLink = () => {
  emits("VCBannerClick");
};

const defineBanner = computed(() => {
  if (!props.tipo) return undefined;

  return EFinanceiroButtonGetter[props.tipo];
});
</script>

<style lang="scss" scoped>
@use "@/styles/theme/f360-theme";
@use "@/styles/variables";

.f360-banner-aviso-financeiro {
  font-family: $fontFamily;
  width: auto;
  height: 30px;
  max-height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.7rem;
  border-radius: 0.3125rem;
  color: #2e2e2e;
  font-weight: 400;
  font-size: 14px;
  line-height: 32px;
  .content-left {
    display: flex;
    align-items: center;
    color: #fff;
    width: 80%;
    .icon-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: nowrap;
      padding: 1px 1.5px 1px 1px;
      margin-right: 10px;
      .icon {
        font-size: 19px;
        padding: 1px;
        bottom: 0.5px;
        position: relative;
      }
    }
  }
  .content-right {
    display: flex;
    align-items: center;
    p {
      margin-right: 10px;
    }
  }
  .banner-button {
    height: 32px;
    width: fit-content;
    padding: 0 5px;
    border-radius: 5px;
    border: none;
    background-color: transparent;
    cursor: pointer;
    &__label {
      display: flex;
      align-items: center;
      gap: 3px;
      font-family: $fontFamily;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      &--small {
        font-size: 10px;
        line-height: 10px;
      }
    }
    &__icon {
      font-size: 18px;
    }
    @media (min-width: 768px) and (max-width: 1200px) {
      .display-btn-text {
        display: none;
      }
    }
  }
  .banner-button:hover {
    background-color: transparent;
  }
  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: row;
    height: auto;
    padding: 0.5rem 1rem;
    .content-left {
      display: flex;
      flex-direction: column;
      p {
        text-align: left;
      }
      .icon-wrapper {
        border: none;
        display: none;
        .icon {
          display: none;
        }
      }
    }
    .display-btn-text {
      display: none;
    }
  }
}
</style>
